/** Person overlay key shapes and pre-resolved GraphQL display rows. */

const OVERLAY_BAG_KEY_PREFIX = "custom:" as const;

export type PersonOverlayAttributeKind = "SCALAR" | "BAG";

export type PersonOverlayAttributeKey = {
  key: string;
  label?: string | null;
  kind: PersonOverlayAttributeKind;
  powerOrAdminOnly?: boolean | null;
};

export type PersonOverlayAttributeValue = {
  key: string;
  displayValue?: string | null;
};

export type OverlayAttributeBadgeSource = {
  overlayAttributeValues?: PersonOverlayAttributeValue[] | null | undefined;
};

export const toOverlayBagKey = (
  attributeType: string,
  subtype?: string | null
): string => `${OVERLAY_BAG_KEY_PREFIX}${attributeType}:${subtype ?? ""}`;

export const parseOverlayBagKey = (
  value: string
): { attributeType: string; subtype: string } | null => {
  if (!value.startsWith(OVERLAY_BAG_KEY_PREFIX)) {
    return null;
  }
  const rest = value.slice(OVERLAY_BAG_KEY_PREFIX.length);
  const colon = rest.indexOf(":");
  if (colon < 0) {
    return rest ? { attributeType: rest, subtype: "" } : null;
  }
  const attributeType = rest.slice(0, colon);
  if (!attributeType) {
    return null;
  }
  return { attributeType, subtype: rest.slice(colon + 1) };
};

export const isOverlayBagKey = (value: string): boolean =>
  parseOverlayBagKey(value) != null;

export const getOverlayAttributeDisplayValue = (
  attributeKey: string,
  source: OverlayAttributeBadgeSource | null | undefined
): string | null => {
  if (!source?.overlayAttributeValues) {
    return null;
  }
  const match = source.overlayAttributeValues.find(
    (row) => row.key === attributeKey
  );
  const value = match?.displayValue?.trim();
  return value ? value : null;
};
